
<info>
	<div style="text-align: left;">
		<ul>
			<li>
				<span style="font-weight: bold;">Administrator</span> users can configure the application and do anything within the application without restriction.
			</li>
			<li>
				<span style="font-weight: bold;">Regular</span> users cannot configure the application, but they can create and share networks, and have networks shared with them by other users.
			</li>
			<li>
				<span style="font-weight: bold;">Observer</span> users cannot configure the application or create or share networks, but they can have networks shared with them by other users.
			</li>
		</ul>
	</div>
</info>

